import { render, staticRenderFns } from "./CardChannel.vue?vue&type=template&id=38dcd274&scoped=true&"
import script from "./CardChannel.vue?vue&type=script&lang=js&"
export * from "./CardChannel.vue?vue&type=script&lang=js&"
import style0 from "./CardChannel.vue?vue&type=style&index=0&id=38dcd274&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dcd274",
  null
  
)

export default component.exports